import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../../components/BreadCrumbs/BreadCrumbs';
import Page from '../../../../components/Page/Page';
import { SETTINGS } from '../../../../routes/routeConstants';
import ChangePassword from './ChangePassword';
import Contacts from './Contacts';
import KycInformation from './KycInformation';

const AccountAndSecurity = () => {
  const { pathname } = useLocation();
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Settings`,
        link: `/${SETTINGS}`,
      },
      {
        name: `Account and Security`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Account & Security'>
      <Container>
        <BreadCrumbs pathData={pathArr as any} hideOnWeb />
        <FormHeaderLabel>Account and Security</FormHeaderLabel>
        <Contacts />
        <ChangePassword />
        <KycInformation />
      </Container>
    </Page>
  );
};

export default AccountAndSecurity;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormHeaderLabel = styled.div`
  display: flex;
  font-size: 22px;
  line-height: 22px;
  font-weight: 600;
`;
